import React, { useState } from 'react';
import api from '../../api/axiosConfig';
import { endpoints } from '../../api/endpoints';
import { Header } from '../../components/Header/Headers';
import BatchList from './Components/BatchList';
import CreateNewQRBatchModal, { CreateNewQRBatchFormData } from './Components/CreateNewQRBatchModal';

interface QrBatchCreateResponse {
  id?: string;
  batch_id?: string;
  count?: number;
  notes?: string;
}

const GenerateQrCodes: React.FC = () => {
  const [isCreateBatchModalOpen, setIsCreateBatchModalOpen] = useState(false);
  const [isCreatingBatch, setIsCreatingBatch] = useState(false);
  const [createBatchError, setCreateBatchError] = useState<string | null>(null);
  const [batchListRefreshKey, setBatchListRefreshKey] = useState(0);

  const handleCreateBatch = async (data: CreateNewQRBatchFormData) => {
    setIsCreatingBatch(true);
    setCreateBatchError(null);

    try {
      const response = await api.post(endpoints.qrTemplates.createBulkWithQr, {
        count: Number(data.quantity),
        notes: data.remarks || '',
      });

      const payload = (response.data || {}) as QrBatchCreateResponse;

      if (!payload.id && !payload.batch_id) {
        throw new Error('Batch created, but the server did not return the created batch details.');
      }

      setBatchListRefreshKey((current) => current + 1);
      setIsCreateBatchModalOpen(false);
      return true;
    } catch (error: any) {
      const message =
        error?.response?.data?.detail?.message ||
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.message ||
        'Failed to create QR batch. Please try again.';

      setCreateBatchError(message);
      return false;
    } finally {
      setIsCreatingBatch(false);
    }
  };

  return (
    <>
      <Header
        title="Generate QR Codes"
        breadcrumb="Admin Console / Generate QR Codes"
        isGenerateQrPage
        onCreateQrBatch={() => setIsCreateBatchModalOpen(true)}
      />
      <BatchList refreshKey={batchListRefreshKey} />
      <CreateNewQRBatchModal
        open={isCreateBatchModalOpen}
        onClose={() => {
          setIsCreateBatchModalOpen(false);
          setCreateBatchError(null);
        }}
        onSave={handleCreateBatch}
        isSubmitting={isCreatingBatch}
        errorMessage={createBatchError}
        onClearError={() => setCreateBatchError(null)}
      />
    </>
  );
};

export default GenerateQrCodes;